import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, MessageCircle, Mail } from "lucide-react";
import { motion } from "framer-motion";
import api, { inr } from "@/lib/api";
import homeMainImage from "@/assets/home_main_image.jpg";
import steamRoomImg from "@/assets/steam_room_hammam.webp";
import drinksImg from "@/assets/drinks_hammam.webp";
import newHugeJacuzziImg from "@/assets/new_huge_jacuzzi.png";
import newCommonShowerImg from "@/assets/new_common_shower.png";
import newDarkRoomImg from "@/assets/new_dark_room.png";
import newDrinksBarImg from "@/assets/new_driniks_bar.png";

export default function Home() {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [testis, setTestis] = useState([]);

  useEffect(() => {
    document.title = "Hammam Mens Spa | Male to Male Spa in Delhi NCR - Gurgaon, Rajouri & Lajpat Nagar";
    api
      .get("/site-settings")
      .then((r) => setSettings(r.data))
      .catch(() => {});
    api
      .get("/services")
      .then((r) => setServices(r.data))
      .catch(() => {});
    api
      .get("/testimonials")
      .then((r) => setTestis(r.data))
      .catch(() => {});
  }, []);

  const hero = settings?.hero || {};

  const getServiceImage = (slug) => {
    if (slug === "service-red") return "/services/SERVICE-RED-HAMMAM.png";
    if (slug === "service-green") return "/services/SERVICE-GREEN-HAMMAM.png";
    if (slug === "service-yellow") return "/services/Service-Yellow.png";
    if (slug === "service-rainbow") return "/services/SERVICE-RAINBOW.png";
    if (slug === "body-polishing") return "/services/BODY-POLISHING.png";
    if (slug === "veet-waxing") return "/services/VEET-WAXING.png";
    if (slug === "trimming") return "/services/TRIMMER.png";
    return "/hero_image_hammam.png";
  };

  const getServiceTheme = (slug) => {
    if (slug === "service-red") {
      return {
        border: "border-2 border-red-500 shadow-red-950/40 hover:border-red-400",
        badgeBg: "bg-red-600 text-white font-extrabold border-red-500",
        badgeText: "HOT THERAPY",
        priceText: "text-red-400",
        btnStyle: "bg-red-600 hover:bg-red-500 text-white rounded-xl px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-all shadow-md shadow-red-950/40 hover:scale-105",
      };
    }
    if (slug === "service-green") {
      return {
        border: "border-2 border-emerald-400 shadow-emerald-950/40 hover:border-emerald-300",
        badgeBg: "bg-emerald-600 text-white font-extrabold border-emerald-500",
        badgeText: "REJUVENATING",
        priceText: "text-emerald-400",
        btnStyle: "bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-all shadow-md shadow-emerald-950/40 hover:scale-105",
      };
    }
    if (slug === "service-yellow") {
      return {
        border: "border-2 border-amber-400 shadow-amber-950/40 hover:border-amber-300",
        badgeBg: "bg-amber-500 text-black font-extrabold border-amber-400",
        badgeText: "MOST POPULAR",
        priceText: "text-amber-400",
        btnStyle: "bg-amber-500 hover:bg-amber-400 text-black font-bold rounded-xl px-5 py-2.5 text-xs uppercase tracking-wider transition-all shadow-md shadow-amber-950/40 hover:scale-105",
      };
    }
    return {
      border: "border-2 border-hgold shadow-yellow-950/40 hover:border-hgold-light",
      badgeBg: "bg-hgold text-black font-extrabold border-hgold",
      badgeText: "PREMIUM",
      priceText: "text-hgold",
      btnStyle: "gold-btn rounded-xl",
    };
  };

  return (
    <div data-testid="home-page">
      {/* SEO keywords (invisible) */}
      <div className="sr-only" aria-hidden="true">
        {hero.seo_keywords}
      </div>

      {/* HERO */}
      <section className="relative min-h-[92vh] overflow-hidden grain -mt-[72px] flex items-center">
        <img
          src="/hero_image_hammam.png"
          alt="Hammam interior"
          className="w-full h-full object-cover absolute inset-0"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-24 lg:pt-32 pb-16 grid grid-cols-1 lg:grid-cols-12 gap-8 w-full">
          <div className="lg:col-span-9">
            <motion.h1
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.25, 1, 0.5, 1] }}
              className="text-3xl lg:text-5xl font-heading text-white mb-8 leading-tight"
            >
              Experience premium male-to-male spa and gay-friendly wellness services
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 35 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.25, ease: [0.25, 1, 0.5, 1] }}
              className="text-hsecondary text-base sm:text-lg mt-6 max-w-3xl leading-relaxed font-normal"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Indulge in absolute luxury, ultimate privacy, and world-class
              massage therapies customized for the modern gentleman. Proudly
              serving clients since 2007.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.45, ease: [0.25, 1, 0.5, 1] }}
              className="flex flex-wrap gap-4 mt-8"
            >
              <a
                href="tel:+919560656913"
                className="gold-btn flex items-center justify-center gap-2.5 px-7 py-3.5 text-xs font-bold uppercase tracking-wider shadow-lg shadow-hgold/20 hover:scale-105 transition-all"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                <Phone size={16} />
                <span>Call Now</span>
              </a>
              <a
                href="https://wa.me/919560656913?text=Hi%20Hammam%20Mens%20Spa,%20I'd%20like%20to%20book%20a%20session."
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2.5 bg-[#25D366] text-black hover:bg-[#20ba5a] px-7 py-3.5 text-xs font-bold uppercase tracking-wider rounded-lg transition-all hover:scale-105 shadow-lg shadow-green-950/30"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                <MessageCircle size={16} className="fill-black stroke-none" />
                <span>WhatsApp Us</span>
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* WHO WE ARE Section */}
      <section className="py-24 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Side: Image */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
            className="lg:col-span-6 relative"
          >
            <div className="relative rounded-2xl overflow-hidden border-2 border-hgold/60 shadow-2xl shadow-hgold/10">
              <img
                src={homeMainImage}
                alt="Who We Are"
                className="w-full h-auto object-cover"
              />
            </div>
          </motion.div>

          {/* Right Side: Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 1, 0.5, 1] }}
            className="lg:col-span-6 space-y-6"
          >
            <h2 className="text-4xl sm:text-5xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-rose-400 to-amber-400 uppercase tracking-wider font-bold">
              Who We Are?
            </h2>
            <div className="text-hsecondary text-base leading-relaxed space-y-6">
              <p>
                Hammam Mens Spa is India’s premier spa and wellness group,
                recognized as a{" "}
                <strong className="text-emerald-400 font-semibold">
                  trusted gay spa, men’s spa, and male-to-male massage
                  destination in Delhi NCR
                </strong>
                . Since our inception, we have been dedicated to redefining
                men’s wellness by creating a space where luxury, privacy, and
                professional care come together to deliver a truly elevated
                relaxation experience.
              </p>
              <p>
                We understand that modern men seek more than just a massage —
                they seek comfort, discretion, and an environment where they can
                unwind without hesitation. That is why Hammam is thoughtfully
                designed to offer a safe, welcoming, and sophisticated setting.
                From expert{" "}
                <strong className="text-amber-300 font-semibold">male-to-male massage</strong>{" "}
                therapies and rejuvenating body treatments to steam, sauna, and
                jacuzzi experiences, every service is tailored to help you
                relax, recharge, and feel your best.
              </p>
              <p>
                Our professional therapists are trained to focus on stress
                relief, muscle relaxation, and overall wellness while
                maintaining the highest standards of hygiene and service.
                Attention to detail and genuine hospitality define every visit,
                ensuring that each guest leaves feeling refreshed, valued, and
                cared for.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Facilities Grid Section */}
      <section className="py-20 border-t border-white/5 bg-[#080808] overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-7xl mx-auto px-6 lg:px-10 mb-8"
        >
          <div className="text-center">
            <h2 className="text-4xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-hgold to-emerald-400 mb-3">
              Our Elite. Discreet. Relaxing. Facilities
            </h2>
            <div className="text-xs uppercase tracking-[0.25em] text-emerald-400/90 font-semibold">
              For The Modern Gentleman
            </div>
          </div>
        </motion.div>
        <div className="relative w-full overflow-hidden py-4">
          <div
            className="flex gap-6 whitespace-nowrap animate-facilities-marquee"
            style={{ width: "max-content" }}
          >
            {[
              { img: steamRoomImg, title: "STEAM & SAUNA" },
              { img: drinksImg, title: "SUNBATH AREA" },
              { img: newHugeJacuzziImg, title: "HUGE JACUZZI" },
              { img: newCommonShowerImg, title: "COMMON SHOWER" },
              { img: newDarkRoomImg, title: "DISCREET DARK ROOM" },
              { img: newDrinksBarImg, title: "DRINKS & LOUNGE BAR" },
              // Duplicate once to make marquee seamless
              { img: steamRoomImg, title: "STEAM & SAUNA" },
              { img: drinksImg, title: "SUNBATH AREA" },
              { img: newHugeJacuzziImg, title: "HUGE JACUZZI" },
              { img: newCommonShowerImg, title: "COMMON SHOWER" },
              { img: newDarkRoomImg, title: "DISCREET DARK ROOM" },
              { img: newDrinksBarImg, title: "DRINKS & LOUNGE BAR" },
            ].map((item, idx) => {
              const facilityBorders = [
                "border-red-500 shadow-red-950/40",
                "border-emerald-400 shadow-emerald-950/40",
                "border-amber-400 shadow-amber-950/40",
                "border-rose-400 shadow-rose-950/40",
                "border-hgold shadow-yellow-950/40",
                "border-cyan-400 shadow-cyan-950/40",
              ];
              const borderColorClass = facilityBorders[idx % facilityBorders.length];
              return (
                <div
                  key={idx}
                  className={`relative rounded-xl overflow-hidden border-2 ${borderColorClass} shadow-lg group w-[85vw] max-w-[340px] sm:max-w-[360px] md:max-w-[400px] shrink-0`}
                >
                  <div className="aspect-square overflow-hidden bg-black/40">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <style>{`
            .animate-facilities-marquee {
              animation: facilities-marquee-scroll 35s linear infinite;
            }
            @keyframes facilities-marquee-scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}</style>
        </div>
      </section>

      {/* SERVICES Section */}
      <section className="py-24 border-t border-white/5 bg-black/40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex justify-between items-end mb-12"
          >
            <div>
              <div className="label-eyebrow mb-3 text-red-400 font-extrabold tracking-widest uppercase">Our Menu</div>
              <h2 className="text-4xl lg:text-5xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-white via-amber-200 to-emerald-400">
                Popular Services
              </h2>
            </div>
            <Link
              to="/services"
              className="gold-btn"
              style={{ padding: "0.5rem 1rem", fontSize: "0.75rem" }}
            >
              View All Services
            </Link>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {services.slice(0, 3).map((s, idx) => {
              const theme = getServiceTheme(s.slug);
              return (
                <motion.div
                  key={s.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.6, delay: idx * 0.15 }}
                  className={`border-2 bg-hpaper ${theme.border} transition-all duration-300 flex flex-col justify-between overflow-hidden rounded-xl shadow-lg group relative`}
                >
                  <div className="aspect-square overflow-hidden relative bg-black/40 flex items-center justify-center">
                    <img
                      src={getServiceImage(s.slug)}
                      alt={s.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className={`absolute top-3 left-3 border px-2.5 py-1 rounded-full text-[10px] font-extrabold tracking-widest uppercase backdrop-blur-md ${theme.badgeBg}`}>
                      {theme.badgeText}
                    </div>
                  </div>
                  <div className="p-6 flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="font-heading text-2xl text-white mb-2">
                        {s.name}
                      </h3>
                      <p className="text-hsecondary text-xs mt-3 leading-relaxed line-clamp-3 min-h-[3rem]">
                        {s.description}
                      </p>
                    </div>
                    <div className="mt-8 border-t border-white/10 pt-6 flex items-center justify-between">
                      <span className={`font-heading text-xl font-bold ${theme.priceText}`}>
                        {inr(s.price)}
                      </span>
                      <Link
                        to={`/book?service_id=${s.id}`}
                        className={theme.btnStyle}
                        style={theme.btnStyle.includes("gold-btn") ? { padding: "0.5rem 1rem", fontSize: "0.75rem" } : {}}
                      >
                        Book Now
                      </Link>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS - marquee */}
      <section className="py-24 lg:py-32 border-t border-white/5 bg-[#080808] overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-7xl mx-auto px-6 lg:px-10 mb-12"
        >
          <div className="label-eyebrow mb-3 text-emerald-400 font-extrabold tracking-widest uppercase">Testimonials</div>
          <h2 className="text-4xl lg:text-5xl font-heading text-transparent bg-clip-text bg-gradient-to-r from-white via-rose-300 to-amber-300">
            In the words of our guests.
          </h2>
        </motion.div>
        <div className="relative overflow-hidden">
          <div
            className="flex gap-6 whitespace-nowrap py-3"
            style={{ animation: "hammam-testi 24s linear infinite" }}
          >
            {[...testis, ...testis, ...testis].map((t, i) => {
              const themes = [
                {
                  border: "border-2 border-red-500 shadow-red-950/40",
                  star: "text-red-400",
                  author: "text-red-400",
                  bg: "bg-gradient-to-b from-red-950/20 via-black to-black",
                },
                {
                  border: "border-2 border-emerald-400 shadow-emerald-950/40",
                  star: "text-emerald-400",
                  author: "text-emerald-400",
                  bg: "bg-gradient-to-b from-emerald-950/20 via-black to-black",
                },
                {
                  border: "border-2 border-amber-400 shadow-amber-950/40",
                  star: "text-amber-400",
                  author: "text-amber-400",
                  bg: "bg-gradient-to-b from-amber-950/20 via-black to-black",
                },
                {
                  border: "border-2 border-rose-400 shadow-rose-950/40",
                  star: "text-rose-400",
                  author: "text-rose-400",
                  bg: "bg-gradient-to-b from-rose-950/20 via-black to-black",
                },
                {
                  border: "border-2 border-hgold shadow-yellow-950/40",
                  star: "text-hgold",
                  author: "text-hgold",
                  bg: "bg-gradient-to-b from-yellow-950/20 via-black to-black",
                },
              ];
              const theme = themes[i % themes.length];
              return (
                <div
                  key={i}
                  className={`border-2 p-8 w-[380px] shrink-0 whitespace-normal rounded-2xl ${theme.border} ${theme.bg} shadow-lg my-2`}
                >
                  <div className={`text-lg mb-3 ${theme.star}`}>
                    {"★".repeat(t.rating)}
                  </div>
                  <p className="text-white/90 leading-relaxed italic mb-4 font-heading text-lg">
                    "{t.quote}"
                  </p>
                  <div className={`label-eyebrow font-semibold ${theme.author}`}>
                    {t.author}, {t.location}
                  </div>
                </div>
              );
            })}
          </div>
          <style>{`@keyframes hammam-testi { from { transform: translateX(0); } to { transform: translateX(-33.33%); } }`}</style>
        </div>
      </section>
      {/* SEO rich text content */}
      <section className="py-24 border-t border-white/5 bg-[#050505]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-4xl mx-auto px-6 lg:px-10"
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <h2 className="font-heading text-3xl sm:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-rose-400 to-amber-300 mb-6 font-bold leading-snug">
              Hammam Mens Spa - The Most Trusted Gay Spa &amp; Men’s Spa in Delhi NCR
            </h2>
            <div className="text-hsecondary text-base leading-relaxed space-y-6 font-normal">
              <p>
                Hammam Mens Spa is a premium men’s spa in Delhi NCR, proudly
                serving clients since 2007. Known as one of the most reputed gay
                spas in Delhi, Hammam offers a luxurious, safe, and discreet
                environment for men seeking relaxation, body rejuvenation, and
                professional male to male massage services.
              </p>
              <p>
                With a strong presence across South Delhi, West Delhi, and
                Gurgaon, Hammam Mens Spa has become a preferred destination for
                those searching for a men’s spa in Delhi, male to male spa in
                Delhi, or a high-quality male to male massage in Delhi NCR. Our
                brand stands for trust, privacy, comfort, and world-class spa
                experiences designed exclusively for men.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="mt-12"
          >
            <h3 className="font-heading text-2xl sm:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-teal-300 to-amber-300 mb-6 font-bold">
              Premium Male to Male Massage &amp; Men’s Spa Services in Delhi
            </h3>
            <div className="text-hsecondary text-base leading-relaxed space-y-6 font-normal">
              <p>
                At Hammam Mens Spa, we specialise in professional male to male
                massage therapies delivered by trained male therapists who
                understand technique, comfort, and personalised care. Each session
                is designed to relieve stress, improve circulation, and promote
                deep relaxation.
              </p>
              <p>Our most sought-after men’s spa services in Delhi include:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/90">
                <li className="text-emerald-400 font-semibold"><span className="text-white/90 font-normal">Male to Male Massage</span></li>
                <li className="text-amber-400 font-semibold"><span className="text-white/90 font-normal">Swedish &amp; Deep Tissue Massage</span></li>
                <li className="text-rose-400 font-semibold"><span className="text-white/90 font-normal">Relaxation &amp; Stress Relief Therapies</span></li>
                <li className="text-cyan-400 font-semibold"><span className="text-white/90 font-normal">Body Polishing &amp; Body Scrubbing</span></li>
                <li className="text-emerald-400 font-semibold"><span className="text-white/90 font-normal">Steam Bath &amp; Sauna</span></li>
                <li className="text-amber-400 font-semibold"><span className="text-white/90 font-normal">Jacuzzi &amp; Sky Jacuzzi Experience</span></li>
                <li className="text-rose-400 font-semibold"><span className="text-white/90 font-normal">Premium Spa Packages &amp; Rituals</span></li>
                <li className="text-cyan-400 font-semibold"><span className="text-white/90 font-normal">Complete Body Care &amp; Grooming Services</span></li>
              </ul>
              <p className="pt-2">
                Whether you are visiting for a short relaxation break or a
                complete wellness experience, Hammam ensures consistent service
                quality across all locations.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="mt-12"
          >
            <h3 className="font-heading text-2xl sm:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-hgold to-rose-400 mb-6 font-bold">
              A Leading Gay Spa in Delhi with Safe &amp; Inclusive Spaces
            </h3>
            <div className="text-hsecondary text-base leading-relaxed space-y-6 font-normal">
              <p>
                Hammam Mens Spa is widely recognised as a safe and inclusive gay
                spa in Delhi, welcoming men from all backgrounds in a respectful
                and judgment-free environment. Privacy, consent, and comfort are
                at the core of our philosophy.
              </p>
              <p>
                Our thoughtfully designed spaces include private therapy rooms as
                well as shared wellness areas, allowing guests to relax at their
                own pace. This commitment has made Hammam a trusted name for those
                searching for a gay spa in Delhi NCR that combines luxury with
                professionalism.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="mt-12"
          >
            <h3 className="font-heading text-2xl sm:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-emerald-400 to-amber-300 mb-6 font-bold">
              World-Class Facilities at Our Men’s Spa in Delhi NCR
            </h3>
            <div className="text-hsecondary text-base leading-relaxed space-y-6 font-normal">
              <p>
                Each Hammam Mens Spa location offers premium infrastructure that
                elevates your spa journey:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/90">
                <li className="text-rose-400 font-semibold"><span className="text-white/90 font-normal">Luxury &amp; Heated Therapy Rooms</span></li>
                <li className="text-emerald-400 font-semibold"><span className="text-white/90 font-normal">Steam &amp; Sauna Bath</span></li>
                <li className="text-amber-400 font-semibold"><span className="text-white/90 font-normal">Large Jacuzzi &amp; Sky Jacuzzi (select branches)</span></li>
                <li className="text-cyan-400 font-semibold"><span className="text-white/90 font-normal">Dark Room Experience</span></li>
                <li className="text-rose-400 font-semibold"><span className="text-white/90 font-normal">Modern Showers &amp; Changing Areas</span></li>
                <li className="text-emerald-400 font-semibold"><span className="text-white/90 font-normal">In-house Bar &amp; Refreshments</span></li>
                <li className="text-amber-400 font-semibold"><span className="text-white/90 font-normal">Clean, Hygienic &amp; Professionally Managed Environment</span></li>
              </ul>
              <p className="pt-2">
                Our facilities are maintained with strict hygiene standards,
                ensuring a safe and relaxing experience every time you visit.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="mt-12"
          >
            <h3 className="font-heading text-2xl sm:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-rose-400 via-red-500 to-amber-400 mb-6 font-bold">
              Convenient Men’s Spa Locations Across Delhi NCR
            </h3>
            <div className="text-hsecondary text-base leading-relaxed space-y-6 font-normal">
              <p>
                Hammam Mens Spa operates from prime locations, making it easy to
                find a men’s spa near you in Delhi NCR:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/90">
                <li className="text-emerald-400 font-semibold"><span className="text-white/90 font-normal">Lajpat Nagar – South Delhi</span></li>
                <li className="text-rose-400 font-semibold"><span className="text-white/90 font-normal">Rajouri Garden – West Delhi</span></li>
                <li className="text-amber-400 font-semibold"><span className="text-white/90 font-normal">Sikandarpur – Gurgaon</span></li>
              </ul>
              <p className="pt-2">
                Each branch delivers the same premium experience, making Hammam a
                reliable choice for anyone looking for a men’s spa in Delhi or
                male to male spa services nearby.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </section>
    </div>
  );
}
